import { z } from 'zod';

import { defaultNullish, mongoIdSchema } from './shared';

export const productTemplateSectionCreateSchema = z.object({
  id: mongoIdSchema.nullish(),
  name: z.string().trim(),
  maxNumberOfWords: z.number(),
  allowHeadings: z.boolean(),
  allowLists: z.boolean(),
  attributeField: z.boolean(),
  // guidelines is an array of stringified tiptap json objects
  guidelinesDocs: z.array(z.string().trim()),
  // examples is an array of stringified tiptap json objects
  examplesDocs: z.array(z.string().trim()),
  order: z.number(),
  exportName: defaultNullish(z.string().nullish()).default(''),
});

export type ProductTemplateSectionCreate = z.infer<typeof productTemplateSectionCreateSchema>;

export const productTemplateCreateSchema = z.object({
  name: z.string().trim(),
  additionalInformation: defaultNullish(z.string().trim().nullish()).default(''),
  useBrandContext: z.boolean(),
  useVoiceExamples: z.boolean(),
  sections: z.array(productTemplateSectionCreateSchema),

  brandId: mongoIdSchema,
  organizationId: mongoIdSchema,
});
export type ProductTemplateCreate = z.infer<typeof productTemplateCreateSchema>;

export const productTemplateSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(productTemplateCreateSchema);

export type ProductTemplate = z.infer<typeof productTemplateSchema>;
